export { default } from './useTheme';